var placeNormalTradeMapper = function (response) {
    var _a, _b;
    if (response) {
        return {
            message: response.msg,
            orderID: response.oid,
            success: true,
            orderList: ((_a = response === null || response === void 0 ? void 0 : response.ord) === null || _a === void 0 ? void 0 : _a.length) > 0
                ? (_b = response === null || response === void 0 ? void 0 : response.ord) === null || _b === void 0 ? void 0 : _b.map(function (x) {
                    return { lotSize: x.lsz, orderId: x.oid };
                })
                : [],
            failedShrs: response.failedShrs ? response.failedShrs : "",
        };
    }
    return {};
};
export default placeNormalTradeMapper;
